import React, { Component } from 'react';

import { MDBRow } from 'mdbreact';
import ImageGallery from 'react-image-gallery';

import '../../../node_modules/react-image-gallery/styles/css/image-gallery.css';

class Real8 extends Component {

  render() {
    
    const images = [
      {
        original: require("../../assets/images/superdry/superdry1.jpg"),
        thumbnail: require("../../assets/images/superdry/superdry1.jpg")
      },
      {
        original: require("../../assets/images/superdry/superdry2.jpg"),
        thumbnail: require("../../assets/images/superdry/superdry2.jpg")
      }
    ];

    return (
      <MDBRow className="Real">
        <h1>Remplacement d'un verre garde corps</h1>
        <ImageGallery
          items={images}
          showIndex={true}
          showPlayButton={false}
          showThumbnails={false}
          showFullscreenButton={false}
        />
      </MDBRow>
    )
  }
}

export default Real8;